import { render, staticRenderFns } from "./LinkNewClientModel.vue?vue&type=template&id=6ceb7574"
import script from "./LinkNewClientModel.vue?vue&type=script&lang=js"
export * from "./LinkNewClientModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports